export type StepContent = string | { items: string[] }

export type Step = {
  step: string
  title: string
  paragraphs: StepContent[]
  note?: string
  action?: {
    label: string
    href: string
  }
}

export const AUTO_STEPS: Step[] = [
  {
    step: 'Schritt 1',
    title: 'Nothelferkurs',
    paragraphs: [
      'Damit du einen Lernfahrausweis beantragen kannst, benötigst du ein gültiges Nothelferkurs-Zertifikat. Unsere Nothelferkurse sind offiziell für den Führerschein anerkannt und bestehen aus einem eLearning (Dauer: ca. 3 Stunden) und aus einem praktischen Kursteil (Dauer: 7 Stunden). Wir gestalten deine Erste-Hilfe-Ausbildung abwechslungsreich und mit vielen praxisnahen Fallbeispielen, so wie du sie auch im Alltag antreffen könntest.',
    ],
    action: {
      label: 'Nothelferkurs buchen',
      href: '/nothelferkurs',
    },
  },
  {
    step: 'Schritt 2',
    title: 'Antrag Lernfahrausweis',
    paragraphs: [
      'Nach dem Nothelferkurs kannst du den Lernfahrausweis beantragen. Dafür musst du das Antragsformular des kantonalen Strassenverkehrsamtes ausfüllen und ein Passfoto, einen Sehtest (durch einen Optiker) und deinen Nothilfeausweis (oftmals nur eine Kopie) beilegen. In den meisten Kantonen funktioniert das leider noch nicht digital.',
      'Wir haben das Gesuchsformular digitalisiert und übernehmen den Papierkram für dich.',
    ],
    action: {
      label: 'Gesuchsformular online ausfüllen',
      href: '/lernfahrausweis',
    },
  },
  {
    step: 'Schritt 3',
    title: 'Theorie / Theorieprüfung',
    paragraphs: [
      'Am einfachsten bereitest du dich mit einer Handy-App auf die Theorieprüfung vor. Wichtig dabei ist, dass du eine App mit den offiziellen Prüfungsfragen des asa (Strassenverkehrsamt) wählst. Zum Lernen stehen rund 300 Fragen zur Verfügung. An der Prüfung (Kat. B und A1 für Auto resp. Motorrad) werden dir 50 Multiple-Choice-Fragen gestellt, die du innerhalb von 45 Minuten beantworten musst. Dabei darfst du maximal 15 Punktefehler machen. Nach bestandener Theorieprüfung erhältst du den Lernfahrausweis.',
      'Für das Lernen der Theorie hat BLINK eine eigene Handy-App mit Webfunktion entwickelt. Natürlich enthält sie die offiziellen Prüfungsfragen. Du kannst sie im App-Store oder Google Play herunterladen.',
    ],
    action: {
      label: 'App herunterladen',
      href: '/theoriepruefung',
    },
  },
  {
    step: 'Schritt 4',
    title: 'Verkehrskunde (VKU)',
    paragraphs: [
      'Der Verkehrskunde-Unterricht, kurz und umgangssprachlich «VKU», ist obligatorisch (für Auto und Motorrad) und findet an zwei Abenden à je vier Stunden statt. Achtung: Damit du den VKU besuchen darfst, musst du einen gültigen Lernfahrausweis besitzen.',
      'Da im VKU wichtige Inhalte für die Sicherheit im Verkehr vermittelt wird, empfehlen die Strassenverkehrsämter den Kurs vor Antritt der ersten praktischen Fahrlektion zu absolvieren. Die meisten Fahrschulen bieten einen VKU an.',
    ],
    action: {
      label: 'VKU online buchen',
      href: '/vku',
    },
  },
  {
    step: 'Schritt 5',
    title: 'Praktischer Fahrunterricht',
    paragraphs: [
      'Der wohl aufregendste Teil der Fahrausbildung ist der Fahrunterricht. Sobald du im Besitz des Lernfahrausweises bist, kannst du mit dem «L» am Auto herumfahren. Deine Begleitperson muss mind. 23 Jahre alt und drei Jahre im Besitz eines gültigen Fahrausweises der Kategorie B sein. Wir empfehlen dir, zuerst Fahrstunden bei einem Fahrlehrer oder einer Fahrlehrerin zu beziehen und erst danach privat zu fahren. Bereit? Du kannst deine erste Fahrlektion bei uns gleich online buchen.',
    ],
    action: {
      label: 'Probelektion buchen',
      href: '/probelektion',
    },
  },
  {
    step: 'Schritt 6',
    title: 'Fahrprüfung',
    paragraphs: [
      'Im Normalfall meldet dich deine Fahrlehrperson für die praktische Fahrprüfung an, wenn du dafür bereit bist. Die Fahrprüfung dauert 60 Minuten, wovon aber nur 45 Minuten reine Fahrzeit sind. Bestehst du die Prüfung, erhältst du umgehend den provisorischen Führerausweis (Führerschein auf Probe) für 3 Jahre. Innerhalb der ersten 12 Monate dieser Probezeit musst du einen WAB Weiterbildungskurs absolvieren (siehe unten 2. Phase). Nach Ablauf der dreijährigen Probezeit erlangst du den definitiven Führerausweis.',
    ],
  },
  {
    step: 'Schritt 7',
    title: '2. Phase / WAB Kurs',
    paragraphs: [
      'Nach bestandener Fahrprüfung befindest du dich in der 2. Phase der Ausbildung. Innerhalb der ersten 12 Monate der dreijährigen Probezeit musst du den WAB Kurs besuchen. Dieser dauert einen ganzen Tag. Der definitive Führerausweis wird dir erst nach Ablauf der Probezeit ausgestellt – vorausgesetzt, du hast den WAB Kurs fristgerecht absolviert und es liegen keine Widerhandlungen vor.',
    ],
    action: {
      label: 'WAB Kurs buchen',
      href: '/wab-kurse',
    },
  },
]

export const MOTORCYCLE_STEPS: Step[] = [
  {
    step: 'Schritt 1',
    title: 'Nothelferkurs',
    paragraphs: [
      'Um deinen Lernfahrausweis beantragen zu können, brauchst du ein gültiges Nothilfekurs-Zertifikat. Die BLINK Nothelferkurse sind offiziell anerkannt für den Führerschein. Sie beinhalten einen eLearning-Teil, der ungefähr 3 Stunden dauert, sowie einen praktischen Teil von 7 Stunden. Wir sorgen dafür, dass deine Ausbildung in Erster Hilfe abwechslungsreich und voll von praxisnahen Beispielen ist, wie du sie im Alltag erleben könntest.',
    ],
    note: 'Den Nothelferkurs musst du nur besuchen, wenn dies deine erste Führerschein-Kategorie ist.',
    action: {
      label: 'Nothelferkurs buchen',
      href: '/nothelferkurs',
    },
  },
  {
    step: 'Schritt 2',
    title: 'Antrag Lernfahrausweis',
    paragraphs: [
      'Sobald du den Nothelferkurs absolviert hast, darfst du den Lernfahrausweis beantragen. Hierfür musst du das Antragsformular deines Wohnkantons ausfüllen und zusätzlich ein Passfoto, einen Sehtest (von einem Optiker durchgeführt), sowie deinen Nothilfeausweis einzureichen. Leider ist es in den meisten Kantonen noch nicht möglich, diesen Vorgang online zu erledigen.',
      'Übersicht zu den Motorrad-Kategorien:',
      {
        items: [
          'Kat. A1 (Motorräder bis 125ccm, max. 11 kW): Ab 16 Jahren',
          'Kat. A2 resp. «A beschränkt» (bis 35kW): Ab 18 Jahren',
          'Kat. A (ohne Einschränkungen): Kein Direkteinstieg möglich. Mind. 2 Jahre Fahrpraxis mit Kat. A2 werden vorausgesetzt.',
        ],
      },
      'Um dir Arbeit und Zeit zu sparen, haben wir das Antragsformular digitalisiert und kümmern uns für dich um den gesamten Papierkram.',
    ],
    action: {
      label: 'Gesuchsformular online ausfüllen',
      href: '/lernfahrausweis',
    },
  },
  {
    step: 'Schritt 3',
    title: 'Theorie / Theorieprüfung',
    paragraphs: [
      'Die beste Vorbereitung auf die Theorieprüfung gelingt dir mit einer Theorie-App für dein Handy. Achte darauf, dass du eine App auswählst, welche die offiziellen Prüfungsfragen der Vereinigung der Strassenverkehrsämter (asa) enthält. Die Theorieprüfung für die A-Kategorien ist dieselbe wie für Kat. B (Auto). Dabei musst du 50 Multiple-Choice-Fragen in max. 45 Minuten beantworten und darfst höchstens 15 Fehlerpunkt sammeln. Nachdem du die Prüfung erfolgreich bestanden hast, wird dir der Lernfahrausweis ausgehändigt.',
      'BLINK hat zur Unterstützung beim Lernen eine eigene Handy-App entwickelt, die natürlich alle offiziellen Prüfungsfragen beinhaltet. Du kannst sie dir im App-Store oder bei Google Play herunterladen.',
    ],
    note: 'Die Theorieprüfung musst du nur absolvieren, wenn dies deine erste Führerschein-Kategorie ist. Danach ist sie grundsätzlich auch für weitere Ausweiskategorien gültig.',
    action: {
      label: 'App herunterladen',
      href: '/theoriepruefung',
    },
  },
  {
    step: 'Schritt 4',
    title: 'Verkehrskunde (VKU)',
    paragraphs: [
      'Der Verkehrskunde-Unterricht, auch bekannt als «VKU», ist obligatorisch (für Auto und Motorrad). Er findet normalerweise an zwei Abenden à je vier Stunden statt.',
      'Da im VKU wichtige Inhalte für die Sicherheit im Verkehr vermittelt wird, empfehlen die Strassenverkehrsämter den Kurs vor Antritt des Grundkurses zu absolvieren – spätestens jedoch vor der praktischen Prüfung. Die meisten Fahrschulen bieten einen VKU an.',
    ],
    note: 'Falls du bereits in Besitz der Kat. B (Auto) oder A1 (Roller) bist, dann musst du den VKU natürlich nicht ein zweites Mal besuchen.',
    action: {
      label: 'VKU online buchen',
      href: '/vku',
    },
  },
  {
    step: 'Schritt 5',
    title: 'Grundkurs 1-3',
    paragraphs: [
      'Sobald du die Theorieprüfung in der Tasche hast, kannst du mit der praktischen Grundausbildung loslegen. Denk daran, dass dein Lernfahrausweis nur vier Monate lang gültig ist. Sobald du die Grundausbildung abgeschlossen hast, verlängert sich die Gültigkeit deines Lernfahrausweises um weitere 12 Monate.',
      'Mit deinem Lernfahrausweis darfst du allein auf die Strasse, allerdings musst du das «blaue L» deutlich sichtbar am Heck deines Motorrads anbringen. Eine Begleitperson darf nur dann mitfahren, wenn sie bereits in Besitz deiner angestrebten Führerschein-Kategorie ist.',
    ],
    note: 'Falls du den Führerausweis Kat. A1 vor dem 1. Januar 2021 erworben hast und nun einen Lernfahrausweis für die Kat. A2 besitzt, dann musst du nur Teil 3 des Grundkurses absolvieren.',
    action: {
      label: 'Motorrad Grundkurs online buchen',
      href: '/motorrad-grundkurs',
    },
  },
  {
    step: 'Schritt 6',
    title: 'Fahrprüfung',
    paragraphs: [
      'Idealerweise klärst du mit deiner Fahrlehrperson im Rahmen einer Prüfungssimulation ab, ob du prüfungsreif bist. Falls du dich selbstständig anmelden möchtest, empfehlen wir dir, eine Woche vor der Prüfung eine Einzellektion oder einen Prüfungsvorbereitungskurs zu absolvieren. So hast du ein gutes Gefühl und kannst allfällige Mängel noch korrigieren. Jedenfalls solltest du bis zum Prüfungstag ausreichend Kilometer zurückgelegt haben.',
    ],
    note: 'Wenn du bereits in Besitz der Kat. B (Auto) bist, dann musst du für die Kat. A1 keine praktische Prüfung absolvieren.',
    action: {
      label: 'Prüfungsberichte ansehen',
      href: '/praktische-pruefung-motorrad',
    },
  },
  {
    step: 'Schritt 7',
    title: '2. Phase / WAB Kurs',
    paragraphs: [
      'Nach bestandener praktischer Prüfung für die Kat. A2 gilt man als Neulenker:in – für die Kat. A1 gilt dies jedoch nicht. Falls du die dreijährige Probezeit noch nicht mit der Kat. B (Auto) absolviert hast, beginnt diese direkt nach der praktischen Prüfung. In diesem Fall musst du innerhalb des ersten Jahres nach bestandener Fahrprüfung den WAB Kurs besuchen. Dieser dauert einen ganzen Tag. Hier findest du alle Informationen zum WAB Kurs.',
    ],
    note: 'Wenn du den WAB Kurs bereits mit der Kat. B (Auto) absolviert hast, musst du ihn natürlich nicht ein zweites Mal absolvieren.',
    action: {
      label: 'WAB Kurs buchen',
      href: '/wab-kurse',
    },
  },
]
